module.exports = __webpack_public_path__ + "c13064b8787a8ea4c1cf417bd403f642.svg";